<template>
    <v-dialog-old ref="dialog" id="medflexClinic" :overflow="true">
        <DoctorDialog ref="doctorDialog" @updated="updateTable"/>

        <fieldset disabled>
            <legend>Клиника МЕДФЛЕКС</legend>
            <span style="display: flex;">
                <span style="white-space: nowrap; width: 90px; color: #666;">Shop id</span>
                <input :value="M.shop_id" readonly/>
            </span>
            <span style="display: flex;">
                <span style="white-space: nowrap; width: 90px; color: #666;">Название</span>
                <input :value="M.clinic_name" readonly/>
            </span>
            <span style="display: flex;">
                <span style="white-space: nowrap; width: 90px; color: #666;">Адрес</span>
                <input :value="M.address" readonly/>
            </span>
        </fieldset>

        <fieldset style="overflow: visible;">
            <legend>Клиника ДОКТУ</legend>
            <div v-if="M.clinic"
                 class="textarea"
                 style="position: relative; background-color: #f8f8f8 !important;">
                <span>{{ M.clinic.name }}</span>
                <br>
                <small>{{ M.clinic.cityName }}, {{ M.clinic.address }}</small>
                <button v-if="!M.good_match" class="tiny redHover" @click.prevent="M.clinic = null"
                        style="position: absolute; right: 2px; top: 2px;">
                    ✖
                </button>
            </div>
            <v-select v-else-if="!selectedClinic"
                      v-on:remove="selectClinic"
                      :options="foundClinics"
                      @search-change="findClinics"
                      placeholder="Поиск клиник...">
                <template v-slot="{ option }">
                    <div class="textarea" >
                        <span>{{ option.text }}</span>
                        &nbsp;&nbsp;&nbsp;
                        <span v-if="option.networkName !== null" class="label bg-red">
                            {{ option.networkName }}
                        </span>
                        <br>
                        <small>{{ option.cityName }}, {{ option.address }}</small>
                    </div>
                </template>
            </v-select>
            <div v-else class="textarea" style="position: relative;">
                <span>{{ selectedClinic.name }}</span><br />
                <small>{{ selectedClinic.cityName }}, {{ selectedClinic.address }}</small>
                <button class="tiny redHover" @click.prevent="selectedClinic = null"
                        style="position: absolute; right: 2px; top: 2px;">
                    ✖
                </button>
            </div>
        </fieldset>

        <v-table id="medflexDoctorsTable"
                 :request-uri="'onlineAppointments/clinic/' + M.id + '/getDoctors'"
                 pagesize="25"
                 ref="table">
            <template v-slot:header>
                <v-tr>
                    <v-th name="doctor_medflex" sort="name" minwidth="200">
                        Врач МЕДФЛЕКС
                    </v-th>
                    <v-th name="doctor_doctu" minwidth="200">
                        Врач ДОКТУ
                    </v-th>
                    <v-th name="is_matched" sort="doctu_doctor_id" width="150">
                        Статус
                    </v-th>
                </v-tr>
                <v-tr>
                    <v-th name="doctor_medflex" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="doctor_doctu" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="is_matched" v-slot="{ filter }">
                        <v-select
                            v-model="filter.value"
                            :options="[
                                    {
                                       text: '\u00a0',
                                       value: null,
                                    },
                                    {
                                        text: 'Связан',
                                        value: '1',
                                    },
                                    {
                                        text: 'Не связан',
                                        value: '0',
                                    },
                            ]"
                        ></v-select>
                    </v-th>
                </v-tr>
            </template>
            <template v-slot:row="{ item, index }">
                <v-tr class="hover"
                      :id="'md-tr-' + item.id"
                      @click="(row, event) => handleRowClick(event, item, row)">
                    <v-td name="doctor_medflex">
                        <b>{{ item.name }}</b>
                        <br>
                        <span>{{ item.specialitiesAsText }}</span>
                    </v-td>
                    <v-td name="doctor_doctu">
                        <template v-if="item.doctor">
                            <b>{{ item.doctor.fullname }}</b>
                            <br>
                            <span>{{ item.doctor.specialitiesAsText }}</span>
                        </template>
                    </v-td>
                    <v-td name="is_matched" align="right">
                        <span>{{ item.isMatched ? 'Связан' : 'Не связан' }}</span>
                    </v-td>
                </v-tr>
            </template>
        </v-table>

        <template v-slot:footer>
            <v-loading-component @click="save">
                <template slot-scope="{ loadingClass }">
                    <button :class="[{green: !M.clinic && selectedClinic}, loadingClass]"
                            :disabled="M.clinic || !selectedClinic">
                        Сохранить
                    </button>
                </template>
            </v-loading-component>
        </template>
    </v-dialog-old>
</template>

<script>
import DoctorDialog from "@dialogs/admin/onlineAppointments/Doctor";

export default {
    components: {
        DoctorDialog
    },
    data: function () {
        return {
            M: {
                id: null,
                clinic_name: null,
                good_match: false,
                address: null,
                shop_id: null,
                clinic: null,
            },
            foundClinics: [],
            selectedClinic: null,
            clinicSearchRequest: null,
            originalClinicId: null,
        };
    },
    methods: {
        resetData() {
            this.M = {
                id: null,
                clinic_name: null,
                address: null,
                shop_id: null,
                clinic: null,
            };
            this.foundClinics = [];
            this.selectedClinic = null;
            this.clinicSearchRequest = null;
            this.originalClinicId = null;
        },
        show(id) {
            this.resetData();

            return this.axios.get('onlineAppointments/clinic/' + id + '/read').then(response => {
                Object.assign(this.M, response.data);
                this.originalClinicId = response.data.clinic?.id;
                this.$refs.dialog.show();
            });
        },
        save(btn) {
            if (this.M.clinic || !this.selectedClinic) {
                return;
            }

            btn.startLoadingAnimation();

            this.axios.post('onlineAppointments/clinic/' + this.M.id + '/save', {
                clinic_id: this.selectedClinic.id,
            }).then(response => {
                btn.stopLoadingAnimation();
                this.$emit('updated');
                this.$bus.fire('updateMenu');
                this.$refs.dialog.hide();
            }).catch(response => {
                if (response.status === 'error') {
                    this.$modal('Выбранная клиника уже имеет другую связь с Медфлексом', {
                        name: 'ОК',
                        callback: () => {
                            btn.stopLoadingAnimation();
                        }
                    }, {
                        callback: () => {
                            btn.stopLoadingAnimation();
                        }
                    }, false, 'only-text-dialog');
                }
            });
        },
        findClinics(query) {
            if (this.clinicSearchRequest) {
                this.clinicSearchRequest.cancel();
            }

            if (query.length > 2) {
                this.clinicSearchRequest = this.axios.CancelToken.source();

                this.axios.post('/clinicsAutocomplete', {
                    q: query,
                    filter: {
                        cityName: this.M.clinic_city,
                    }
                }, {
                    cancelToken: this.clinicSearchRequest.token
                }).then(res => {
                    this.foundClinics = res.data.suggestions.map(item => {
                        return {
                            id: item.data.id,
                            text: item.data.name,
                            cityName: item.data.cityName,
                            networkName: item.data.networkName,
                            address: item.data.address,
                            children: item.data.children,
                        }
                    })
                }).catch(() => {})
            } else {
                this.foundClinics = [];
            }
        },
        selectClinic(payload) {
            this.selectedClinic = {
                id: payload.id,
                name: payload.text,
                cityName: payload.cityName,
                address: payload.address
            };

            this.foundClinics = [];
        },
        handleRowClick(event, item, row) {
            row.startLoadingAnimation();

            this.$refs.doctorDialog.show(item.id, this.selectedClinic?.id ?? this.M.clinic?.id)
                .then(() => row.stopLoadingAnimation())
                .catch(() => row.stopLoadingAnimation());
        },
        updateTable() {
            this.$refs.table.update();
            this.$emit('updated');
        }
    },
}
</script>

<style scoped>
#medflexDoctorsTable {
    height: calc(80vh - 250px);
    margin-top: 10px;
}
</style>
